module.exports = __webpack_public_path__ + "static/media/back.da9d4613.jpg";